import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { OperatorDetails, OperatorTransactionFee } from './operator.models';

@Injectable({ providedIn: 'root' })
export class OperatorApiService {
  private readonly http = inject(HttpClient);

  getById(id: number): Observable<OperatorDetails> {
    return this.http.get<OperatorDetails>(`${environment.apiUrl}/operators/${id}`);
  }

  getTransactionFeeByDomain(domain: string): Observable<OperatorTransactionFee> {
    return this.http.get<OperatorTransactionFee>(
      `${environment.apiUrl}/operators/transaction-fee/by-domain/${encodeURIComponent(domain)}`,
    );
  }
}
